function checkForStock() {
    const escBlock = document.querySelector('#esc-oos-form');
    const submitButton = document.querySelector('.product-submit.action-button.submit');

    if (submitButton.hasAttribute('disabled') || submitButton.disabled) {
        escBlock.style.display = 'block';
    } else {
        escBlock.style.display = 'none';
    } 
  }

  
  function initMutationObserver() {
  const targetNode = document.body;
  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let container = document.querySelector('.shopify-product-form');

        if (container) {
          console.log(`Class "${container?.className}"are now present in the DOM.`);
          checkForStock();
        }
      }
    }
  });

  observer.observe(targetNode, observerOptions);
}

document.addEventListener('DOMContentLoaded', initMutationObserver);